<template lang="pug">
    #mapa-leaflet(:style='{ height: height }', style='position: relative')
        div(:id='idMapa', :style='{ height: height }')
        DrawerMenuCamadas(
            :show='ativarMenuCamadas',
            :menuMaior='menuMaior',
            :mapa='mapa || {}',
            :showStatesLayers='showStatesLayers',
            :limparMenuCamadasAtivo='limparMenuCamadasAtivo',
            @closeDrawerMenuCamadas='toggleMenuCamadas',
            @resetarLimparMenuCamadasAtivo='limparMenuCamadasAtivo = false',
            @atualizarListaCamadasModalInspecionar='atualizarListaCamadasModalInspecionar'
        )
        DrawerMenuArea(
            :show='ativarMenuArea',
            :menuMaior='menuMaior',
            :mapConfigControls='mapConfig.controls',
            :limparMenuAreaAtivo='limparMenuAreaAtivo',
            @rulerActivate='rulerActivate',
            @drawControlCalc='drawControlCalc',
            @closeDrawerMenuArea='toggleMenuArea',
            @resetarLimparMenuAreaAtivo='limparMenuAreaAtivo = false'
        )
        FerramentasSentinelHub(
            :show='ativarFerramentasSentinelHub',
            :menuMaior='menuMaior',
            :mapConfigControls='mapConfig.controls',
            :mapa='mapa'
            @closeFerramentasSentinelHub='toggleFerramentasSentinelHub',
            @resetarLimparMenuFerramentasAtivo='limparMenuFerramentasAtivo = false'
        )
        DrawerInspecionarCamadas(
            :show='mostrarDrawerInspecionar',
            :geometria='geometriaAcao',
            :camadas='camadasInspecao',
            :menuMaior='menuMaior',
            @fechar='fecharDrawerInspecionar'
        )
        .drawer-historico-agricola(v-if='mostrarDrawerHistoricoAgricola && mapa')
            DrawerHistoricoAgricola(
                :show='mostrarDrawerHistoricoAgricola',
                :geometria='geometriaAcao',
                :featureGroup='featureGroup',
                :mapa='mapa',
                @drawerHistoricoAgricolaFechar='drawerHistoricoAgricolaFechar'
            )
        .selecionar-camadas
            ModalSelecionarCamadas(
                :show='mostrarModalSelecionarCamadas',
                :camadasInspecao='camadasInspecao',
                @fechar='mostrarModalSelecionarCamadas = false',
                @inspecionar='inspecionar'
            )
        .enviar-diagnostico
            ModalEnviarGeometriaDiagnostico(
                :show='mostrarModalEnviarGeometriaDiagnostico',
                :geometria='geometriaAcao',
                @fechar='mostrarModalEnviarGeometriaDiagnostico = false'
            )
</template>

<script>
import L from 'leaflet';
import 'leaflet-easybutton';
import 'leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-easybutton/src/easy-button.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.js';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.css';
import 'leaflet-contextmenu';
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.js';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.css';

import OptionsRuler from '@/constants/OptionsRuler';
import DrawCalc from '@/constants/DrawCalc';
import geometryUtils from '@/utils/mapa/geometry.js';
import BuscaCar from '@/components/mapa/buscaCar/BuscaCar.vue';

import { DEFAULT_CONFIG, TILE_LAYER_CONFIG } from '@/utils/mapa/mapa.config';

import i18n from '@/main';

import { mapState, mapActions } from 'vuex';

import { sortBy } from 'lodash';

import ufsData from '@/components/inteligenciaTerritorial/ufs.json';

import ControleLeafletComComponenteVue from '@/utils/mapa/ControleLeafletComComponenteVue';
import DrawerMenuCamadas from '@/components/DrawerMenuCamadas';
import DrawerMenuArea from '@/components/DrawerMenuArea';
import FerramentasSentinelHub from '@/components/sentinelHub/FerramentasSentinelHub';
import DrawerInspecionarCamadas from '@/components/DrawerInspecionarCamadas';
import DrawerHistoricoAgricola from '@/components/DrawerHistoricoAgricola';
import ModalSelecionarCamadas from '@/components/ModalSelecionarCamadas';
import ModalEnviarGeometriaDiagnostico from '@/components/ModalEnviarGeometriaDiagnostico';

import InteligenciaTerritorialService from '@/services/InteligenciaTerritorialService';
import UtilsService from '@/services/UtilsService';
import LocalidadeService from '@/services/LocalidadeService';

import EventBus from '@/utils/eventBus';

export default {
    name: 'MapaInteligenciaTerritorial',

    components: {
        DrawerMenuCamadas,
        DrawerMenuArea,
        FerramentasSentinelHub,
        DrawerInspecionarCamadas,
        DrawerHistoricoAgricola,
        ModalSelecionarCamadas,
        ModalEnviarGeometriaDiagnostico
    },

    props: {
        height: {
            required: false,
            type: String,
            default: '100%'
        },

        mapConfig: {
            required: false,
            type: Object,
            default: () => ({})
        },

        mapLayersConfigs: {
            required: false,
            type: Array
        },

        idMapa: {
            required: true,
            type: String
        },

        controleCulturaMapa: {
            type: String,
            default: ''
        },

        siglaEstado: {
            type: String,
            default: ''
        },

        idsMunicipios: {
            type: Array
        },

        tipoAgrupamento: {
            type: String,
            default: 'PAIS'
        },

        showStatesLayers: {
            type: Boolean,
            required: false,
            default: true
        },

        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            mapa: null,
            config: {},
            featureGroup: L.featureGroup(),
            mapLayers: null,
            camadas: [],
            desabilitaZoom: false,
            fullscreenAtivado: false,
            selectorIdMapa: '',
            ufsLayer: null,
            municipiosLayer: null,
            carLayer: null,
            carMarkers: null,
            estadoSelecionado: null,
            corEstadoSelecionado: null,
            municipioSelecionado: null,
            corMunicipioSelecionado: null,
            contornoMunicipioSelecionado: null,
            mudancaAgrupamento: null,
            municipioNome: null,
            drawPolygonCalc: null,
            ativarMenuCamadas: false,
            limparMenuCamadasAtivo: false,
            ativarFerramentasSentinelHub: false,
            ativarMenuArea: false,
            limparMenuAreaAtivo: false,
            geometriaAcao: {},
            mostrarModalEnviarGeometriaDiagnostico: false,
            mostrarModalSelecionarCamadas: false,
            mostrarDrawerInspecionar: false,
            mostrarDrawerHistoricoAgricola: false,
            camadasInspecao: [],
            pinIcon: null,
            pesquisaExterna: false,
            buscaCarGeometria: null,
            siglaEstadoBkp: null,
            layerMuncipioSelecionado: null,
            ranqueados: null,
            estadoData: null
        };
    },
    computed: {
        ...mapState({
            filtroState: state => state.filtroInteligenciaTerritorial,
            arrayTodosMunicipiosEstadoInteligenciaTerritorial: state => state.arrayTodosMunicipiosEstadoInteligenciaTerritorial
        })
    },
    mounted() {
        this.selectorIdMapa = `#${this.idMapa}`;
        this.config = Object.assign(DEFAULT_CONFIG, this.mapConfig);
        this.usuarioLogado = sessionStorage.getItem('dadosUsuario');

        if (!this.mapa) {
            this.createMap();
        }
        setTimeout(() => {
            if (!this.mapa) {
                this.createMap();
            }
        }, 4500);

        this.addEscListener();
        this.handleFullscreenClick();
        this.handleClickOutsideMenus();

        EventBus.$off('retorna-geometria-car');
        EventBus.$on('retorna-geometria-car', this.showPopupAcoes);
        EventBus.$off('mapaInteligenciaTerritorial:setar-controle-cultura-mapa');
        EventBus.$on('mapaInteligenciaTerritorial:setar-controle-cultura-mapa', this.setarControleCulturaMapa);
    },
    watch: {
        mapConfig: function () {
            this.addMapControls();
        },

        mostrarDrawerInspecionar(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuCamadas(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuArea(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarFerramentasSentinelHub(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        }
    },
    methods: {
        ...mapActions(['setTipoAgrupamentoMapaInteligenciaTerritorial', 'setGeometriaDesenhadaAcao', 'setAcaoEscolhida', 'setIdsMunicipiosInteligenciaTerritorialRanking', 'setArrayTodosMunicipiosEstadoInteligenciaTerritorial']),
        createMap() {
            L.drawLocal = {
                draw: {
                    handlers: {
                        polygon: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaDesenharPoligono'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaContinuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.cliquePrimeiroPontoParaTerminar'
                                )
                            }
                        },
                        polyline: {
                            error: i18n?.t(
                                'mensagens.menuMapa.erro.arestasNaoPodemCruzar'
                            ),
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.desenharLinha'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        },
                        marker: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.inserirMarcador'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        }
                    }
                }
            };

            L.Map.include({
                _initControlPos: function () {
                    const corners = (this._controlCorners = {});
                    const container = (this._controlContainer =
                        L.DomUtil.create('div', 'leaflet-control-container', this._container));

                    function createCorner(vSide, hSide) {
                        const className = `leaflet-${vSide} leaflet-${hSide}`;

                        corners[vSide + hSide] = L.DomUtil.create('div', className, container);
                    }

                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);

                    createCorner('top', 'left');
                    createCorner('top', 'right');
                    createCorner('bottom', 'left');
                    createCorner('bottom', 'right');
                    createCorner('top', 'center');
                    createCorner('middle', 'center');
                    createCorner('middle', 'left');
                    createCorner('middle', 'right');
                    createCorner('bottom', 'center');
                }
            });
            this.mapa = L.map(this.idMapa, {
                ...this.config,
                contextmenu: this.mapConfig.inspecionar,
                contextmenuItems: [
                    {
                        text: this.$t(`mensagens.comuns.inspecionar`),
                        callback: this.selecionarCamadas
                    }
                ],
                maxZoom: 17
            });

            L.tileLayer(TILE_LAYER_CONFIG.url, {
                attribution: TILE_LAYER_CONFIG.attribution
            }).addTo(this.mapa);

            this.ufsLayer = L.geoJSON({type: 'FeatureCollection', features: ufsData.features}, {
                style: feature => ({
                    color: 'var(--white)',
                    weight: 1,
                    opacity: 1,
                    fillColor: this.getColor(feature.properties.density)
                }),
                onEachFeature: (feature, layer) => {
                    layer.on({
                        click: (e) => {
                            this.pesquisaExterna = false;
                            this.zoomToFeature(e);
                            EventBus.$emit('inteligenciaTerritorial:atualizar-filtros-click-mapa-estados', feature.properties.sigla);
                        }
                    });
                }
            });

            this.ufsLayer.addTo(this.mapa);

            this.addMapControls();

            this.featureGroup.addTo(this.mapa);

            this.mapa.on(L.Draw.Event.CREATED, e => {
                let layer = e.layer;
                layer.layerType = e.layerType;
                this.showPopupAcoes(layer);
            });

            $(this.selectorIdMapa).prepend(
                $('#drawer-menu-camadas')
            );
            $(this.selectorIdMapa).prepend(
                $('#drawer-menu-ferramentas')
            );
            $(this.selectorIdMapa).prepend(
                $('#drawer-menu-area')
            );
            $(this.selectorIdMapa).prepend(
                $('#ferramentas-sentinel')
            );
        },

        async setarControleCulturaMapa(tipoRanking, cicloSafra, tipoAgrupamento) {
            if (this.mapa && this.selectorIdMapa) {
                if (this.siglaEstadoBkp !== this.filtroState?.siglaEstado) {
                    this.limparLayerMunicipios();
                }
                await this.setarPesoPorCultura(tipoRanking, cicloSafra, tipoAgrupamento);
                this.refreshMap();
            } else {
                setTimeout(async () => {
                    await this.setarPesoPorCultura(tipoRanking, cicloSafra, tipoAgrupamento);
                    this.refreshMap();
                    if (this.siglaEstadoBkp !== this.filtroState?.siglaEstado) {
                        this.limparLayerMunicipios();
                    }
                }, 4500);
            }
        },

        async processarMostrarMunicipiosMapa(uf, tipoGrafico) {
            if (uf !== null && uf !== '') {
                try {
                    const dadosMunicipio = await InteligenciaTerritorialService.buscarCidadesPorUF(uf, tipoGrafico);
                    await this.mostrarMunicipiosMapa(dadosMunicipio?.data?.features);

                    if (this.estadoSelecionado && this.corEstadoSelecionado) {
                        this.estadoSelecionado.setStyle({fillColor: this.corEstadoSelecionado});
                    }
                    if (this.municipioSelecionado && this.corMunicipioSelecionado && this.contornoMunicipioSelecionado) {
                        this.municipioSelecionado.setStyle({
                            color: this.contornoMunicipioSelecionado,
                            fillColor: this.corMunicipioSelecionado
                        });
                    }
                    this.$emit('setarLoadingRanking', false);
                } catch (error) {
                    this.$notify.error('Ocorreu um erro ao buscar os munícipios!');
                    this.$emit('setarLoadingRanking', false);
                }
            }
        },

        async mostrarMunicipiosMapa(dadosMunicipio, visaoCar) {
            this.$emit('setarLoadingRanking', true);
            if (this.buscaCarGeometria) {
                this.clearLayers(this.buscaCarGeometria);
            }

            let dadosMunicipio_ = null;

            if (this.filtroState?.tipoAgrupamento === 'MUNICIPIO' || this.tipoAgrupamento === 'ESTADO') {
                let fillOpacity = 0.6;
                dadosMunicipio_ = dadosMunicipio.map(municipio => {
                    if (!visaoCar) {
                        const idsMunicipios = this.ranqueados.map(item => item?.idMunicipio);
                        if (idsMunicipios.includes(municipio?.properties?.id)) {
                            municipio.fillOpacity = fillOpacity;
                            fillOpacity -= 0.04;
                            return municipio;
                        }
                    } else {
                        if (Number(this.idsMunicipios[0]) === Number(municipio?.properties?.id)) {
                            return municipio;
                        }
                    }
                });
            }

            dadosMunicipio_ = dadosMunicipio_.filter(item => item !== undefined);

            this.municipiosLayer = L.geoJSON(dadosMunicipio_, {
                style: layer => ({
                    color: 'var(--white)',
                    weight: 1,
                    opacity: 1,
                    fillColor: layer?.properties?.color,
                    fillOpacity: layer?.fillOpacity || 0.2
                }),
                onEachFeature: (feature, layer) => {
                    layer.on({
                        mouseover: this.highlightFeature,
                        mouseout: this.resetHighlight,
                        click: (e) => {
                            this.pesquisaExterna = false;
                            this.zoomToFeature(e);
                            if (this.municipioSelecionado && this.corMunicipioSelecionado && this.contornoMunicipioSelecionado) {
                                this.municipioSelecionado.setStyle({
                                    color: this.contornoMunicipioSelecionado,
                                    fillColor: this.corMunicipioSelecionado
                                });
                            }
                            this.municipioSelecionado = layer;
                            this.contornoMunicipioSelecionado = layer?.options?.color;
                            this.corMunicipioSelecionado = layer?.options?.fillColor;
                            EventBus.$emit('inteligenciaTerritorial:atualizar-filtros-click-mapa-municipios', feature?.properties?.id);
                        }
                    });
                }
            });
            if (this.municipiosLayer) {
                this.municipiosLayer.eachLayer(layer => {
                    if (this.idsMunicipios[0] === layer?.feature?.properties?.id) {
                        if (this.pesquisaExterna === true) {
                            this.zoomToFeature(layer);
                            this.pesquisaExterna = false;
                        }
                        layer.setStyle({color: 'orange', fillColor: 'transparent'});
                    }
                });
            }
            this.limparLayerMunicipios();
            this.municipiosLayer.addTo(this.mapa);
            this.camadas.push(this.municipiosLayer);
        },

        async handleIdsMunicipios(newIdsMunicipios) {
            this.$emit('setarLoadingRanking', true);
            this.pesquisaExterna = true;
            this.municipiosLayer = null;
            if (newIdsMunicipios) {
                if (!this.municipiosLayer) {
                    try {
                        let controleCulturaMapa = null;
                        if (this.controleCulturaMapa === 'producao-') {
                            controleCulturaMapa = 'producao';
                        } else if (this.controleCulturaMapa === 'area-plantada-') {
                            controleCulturaMapa = 'area-plantada';
                        } else {
                            controleCulturaMapa = this.controleCulturaMapa;
                        }
                        const dadosMunicipio = await InteligenciaTerritorialService.buscarCidadesPorUF(this.filtroState?.siglaEstado, controleCulturaMapa || 'area-plantada');
                        await this.mostrarMunicipiosMapa(dadosMunicipio.data.features, 'visaoCar');

                        this.municipiosLayer.eachLayer(async layer => {
                            if (Number(layer?.feature?.properties?.id) === Number(newIdsMunicipios)) {
                                await this.mostrarCars(layer?.feature?.properties, this.controleCulturaMapa);
                            }
                        });
                    } catch (error) {
                        this.$notify.error('Ocorreu um erro ao buscar os munícipios!');
                        this.$emit('setarLoadingRanking', false);
                    }
                } else {
                    this.municipiosLayer.eachLayer(async layer => {
                        if (layer?.feature?.properties?.id === newIdsMunicipios) {
                            await this.mostrarCars(layer?.feature?.properties, this.controleCulturaMapa);
                        }
                    });
                }
            }
            this.pesquisaExterna = false;
        },

        highlightFeature(e) {
            var layer = e.target;

            layer.setStyle({
                weight: 2,
                color: '#666',
                dashArray: '',
                fillOpacity: 0.8
            });

            layer.bindTooltip(layer?.feature?.properties?.nome).openTooltip();
        },

        resetHighlight(e) {
            this.municipiosLayer.resetStyle(e.target);
        },

        limparLayerMunicipios() {
            this.camadas.forEach((layer) => {
                layer.removeFrom(this.mapa);
            });
            this.camadas = [];
        },

        clearLayers(feature) {
            if (feature) {
                this.mapa.removeLayer(feature);
                feature = null;
            }
        },

        changeMapInteractiveDrawers(lockInteractive) {
            let lockFunc = 'enable';
            if (lockInteractive) {
                lockFunc = 'disable';
            }

            this.mapa.dragging[lockFunc]();
            this.mapa.touchZoom[lockFunc]();
            this.mapa.doubleClickZoom[lockFunc]();
            this.mapa.scrollWheelZoom[lockFunc]();
            this.mapa.boxZoom[lockFunc]();
            this.mapa.keyboard[lockFunc]();

            if (this.mapa.tap) this.mapa.tap[lockFunc]();
        },

        acaoClick(dadosImovel) {
            let getIdMunicipio = dadosImovel.codigo.split('-');
            this.$router.push({
                name: 'InteligenciaTerritorialImovel',
                params: {
                    uf: dadosImovel.siglaEstado,
                    codMunicipioIbge: getIdMunicipio[1],
                    car: dadosImovel.codigo
                }
            });
        },

        async mostrarCars(idMunicipio, tipoGrafico) {
            this.$emit('setarLoadingRanking', true);
            this.municipiosLayer.eachLayer(layer => {
                if (layer?.feature?.properties?.id === idMunicipio?.id) {
                    layer.feature.properties.density = 1;
                    const fillColor = this.getColor(layer?.feature?.properties?.density);
                    layer.setStyle({fillColor, fillOpacity: 0.2});
                    this.layerMuncipioSelecionado = layer;
                }
            });
            this.clearLayers(this.carLayer);
            this.clearLayers(this.carMarkers);
            if (this.buscaCarGeometria) {
                this.clearLayers(this.buscaCarGeometria);
            }
            this.limparLayerMunicipios();
            this.layerMuncipioSelecionado.addTo(this.mapa);
            this.camadas.push(this.layerMuncipioSelecionado);
            this.resetHighlight(this.layerMuncipioSelecionado);

            const carIcon = L.icon({
                iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
                iconSize: [18, 26]
            });

            let dadosCAR = null;

            try {
                await InteligenciaTerritorialService.buscarRankingCARPorMunicipio(idMunicipio?.id || this.$route?.params?.municipio, tipoGrafico)
                .then(({ data }) => {
                    dadosCAR = data;
                    EventBus.$emit('inteligenciaTerritorial:setar-renomear-grafico-props', data?.inteligenciaTerritorialDataRankingDTO?.valor);
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível obter os dados dos CARs.'
                });
                this.$emit('setarLoadingRanking', false);
                return;
            }
            const carData = dadosCAR?.inteligenciaTerritorialDataRankingDTO?.valor.map(item => item?.geometry);
            this.carLayer = L.geoJSON(carData, {
                style: feature => ({
                    color: '#FFFF00',
                    weight: 1,
                    opacity: 1,
                    fillColor: 'transparent'
                })
            });
            this.carMarkers = L.featureGroup();

            carData.map((geometry, index) => {
                if (geometry && geometry.coordinates) {
                    geometry.coordinates.forEach(subArray => {
                        subArray.map((coordinates, idx) => {
                            if (idx === 0) {
                                const centroid = this.calculateCentroid(coordinates);
                                const latlng = [centroid[0], centroid[1]];
                                const marker = L.marker(latlng, {icon: carIcon, name: index});
                                marker.on('click', () => this.acaoClick(dadosCAR?.inteligenciaTerritorialDataRankingDTO?.valor[index]));
                                this.carMarkers.addLayer(marker);
                            }
                        });
                    });
                }
            });
            this.carLayer.addTo(this.mapa);
            this.camadas.push(this.carLayer);
            this.carMarkers.addTo(this.mapa);
            this.camadas.push(this.carMarkers);
            this.pesquisaExterna = true;
            this.zoomToFeature(this.carLayer);

            if (idMunicipio.nome !== null && idMunicipio.nome !== undefined) {
                this.municipioNome = idMunicipio.nome;
            }
            if (idMunicipio?.id) {
                if (this.municipioSelecionado) {
                    this.municipioSelecionado.setStyle({color: 'orange', fillColor: 'transparent'});
                }
            } else if (idMunicipio?.id === undefined) {
                if (this.municipioSelecionado) {
                    this.municipioSelecionado.setStyle({color: 'orange', fillColor: 'transparent'});
                }
            }
            if (this.municipioSelecionado && this.corMunicipioSelecionado && this.contornoMunicipioSelecionado) {
                this.municipioSelecionado.setStyle({color: 'orange', fillColor: 'transparent'});
            }
            this.$emit('setarLoadingRanking', false);
        },

        calculateCentroid(coordinates) {
            let totalLat = 0;
            let totalLng = 0;
            let vertexCount = 0;

            coordinates.forEach(subArray => {
                totalLat += subArray[1];
                totalLng += subArray[0];
                vertexCount++;
            });
            const centroidLat = totalLat / vertexCount;
            const centroidLng = totalLng / vertexCount;
            return [centroidLat, centroidLng];
        },

        zoomToFeature(e) {
            if (this.pesquisaExterna === true) {
                this.mapa.fitBounds(e.getBounds());
            } else {
                const layer = e.target;
                this.mapa.fitBounds(layer.getBounds());
            }
        },

        getColor(d) {
            return d === 1 ? '#FFFF00' : '#FFFFF';
        },

        async setarPesoPorCultura(tipoRanking, cicloSafra, tipoAgrupamento) {
            this.pesquisaExterna = true;

            if (this.controleCulturaMapa === 'producao-') {
                this.ufsLayer.eachLayer(layer => {
                    layer.setStyle({fillColor: 'transparent'});
                });
            }

            if (tipoAgrupamento === 'ESTADO' || tipoAgrupamento === 'PAIS') {
                if (this.carLayer) {
                    this.clearLayers(this.carLayer);
                }
                if (this.carMarkers) {
                    this.clearLayers(this.carMarkers);
                }
                if (this.buscaCarGeometria) {
                    this.clearLayers(this.buscaCarGeometria);
                }
                if (this.camadas && this.camadas.length > 0) {
                    this.limparLayerMunicipios();
                }
                if (this.layerMuncipioSelecionado) {
                    this.clearLayers(this.layerMuncipioSelecionado);
                }
            }

            if (tipoAgrupamento === 'ESTADO') {
                this.ufsLayer.eachLayer(layer => {
                    layer.setStyle({fillColor: 'transparent'});
                });
            }

            if (tipoAgrupamento === 'ESTADO' || tipoAgrupamento === 'PAIS') {
                if (this.pesquisaExterna) {
                    this.ufsLayer.eachLayer(layer => {
                        if (layer?.feature?.properties?.sigla === this.filtroState?.siglaEstado) {
                            this.zoomToFeature(layer);
                        }
                    });
                }

                try {
                    await InteligenciaTerritorialService.buscaRankingPaisOuEstadoPorFiltro(
                        tipoRanking || 'pastagem',
                        tipoAgrupamento || 'PAIS',
                        this.filtroState?.objEstado?.sigla || this.$route?.params?.uf,
                        null,
                        cicloSafra
                    ).then(({ data }) => {
                        let fillOpacity = 0.6;
                        this.ranqueados = data?.inteligenciaTerritorialDataRankingDTO?.valor;
                        this.ranqueados = this.ranqueados.map(item => {
                            item.fillOpacity = fillOpacity;
                            fillOpacity -= 0.06;
                            return item;
                        });
                        if (tipoAgrupamento === 'ESTADO') {
                            this.siglaEstadoBkp = this.filtroState?.siglaEstado;
                        }
                    });
                } catch (error) {
                    this.$notify.error({
                        message: 'Não foi possível buscar os dados de ranking.'
                    });
                }
            }

            if (tipoAgrupamento === 'ESTADO') {
                await this.buscarNomesIdsMunicipios(this.ranqueados.map(item => item?.idMunicipio));
                await this.processarMostrarMunicipiosMapa(this.filtroState?.siglaEstado, this.controleCulturaMapa, true);
            }

            if (tipoAgrupamento === 'ESTADO' && this.ranqueados !== null) {
                EventBus.$emit('inteligenciaTerritorial:setar-renomear-grafico-props', this.ranqueados);
            }

            if (tipoAgrupamento === 'PAIS' && this.ranqueados !== null) {
                EventBus.$emit('inteligenciaTerritorial:setar-renomear-grafico-props', this.ranqueados);

                if (tipoAgrupamento === 'PAIS') {
                    const siglaEstados = this.ranqueados.map(item => item?.siglaEstado);
                    if (siglaEstados.length > 0 && siglaEstados[0] !== null) {
                        this.ufsLayer.eachLayer(layer => {
                            if (siglaEstados.includes(layer?.feature?.properties?.sigla)) {
                                layer.feature.properties.density = 1;
                                const fillColor = this.getColor(layer?.feature?.properties?.density);
                                const fillOpacity = this.ranqueados.filter(item => item?.siglaEstado === layer?.feature?.properties?.sigla)[0].fillOpacity;
                                layer.setStyle({fillColor, fillOpacity});
                            }
                        });
                    }
                }
            }

            if (tipoAgrupamento === 'PAIS') {
                this.$emit('setarLoadingRanking', false);
            }

            if (tipoAgrupamento === 'MUNICIPIO') {
                this.$emit('setarLoadingRanking', true);
                this.ufsLayer.eachLayer(layer => {
                    layer.setStyle({fillColor: 'transparent'});
                });
                await this.handleIdsMunicipios(this.idsMunicipios[0]);
            }

            this.pesquisaExterna = true;
            this.$emit('setarPrimeiroCarregamento');
        },

        async buscarNomesIdsMunicipios(arrayIdsMuncipios) {
            EventBus.$emit('inteligenciaTerritorial:setar-array-ids-municipios', arrayIdsMuncipios);
            let todosMunicipios = [];
            let arrayMunicipiosFiltrados = [];

            todosMunicipios = this.arrayTodosMunicipiosEstadoInteligenciaTerritorial || [];
            if (todosMunicipios && todosMunicipios.length > 0) {
                todosMunicipios.forEach(municipio => {
                    const municipioId = Number(municipio.codigo);
                    if (arrayIdsMuncipios.includes(municipioId)) {
                        arrayMunicipiosFiltrados.push(municipio?.nome);
                    }
                });
                this.setIdsMunicipiosInteligenciaTerritorialRanking(arrayMunicipiosFiltrados);
            } else {
                let siglaEstado = this.filtroState?.siglaEstado || this.siglaEstado;
                if (siglaEstado) {
                    await this.buscarEstado(siglaEstado);
                } else {
                    siglaEstado = this.$route?.params?.uf;
                    await this.buscarEstado(siglaEstado);
                }
                await LocalidadeService.findNivel2(this.estadoData?.id, false)
                    .then(({ data }) => {
                        todosMunicipios = data;
                        EventBus.$emit('filtroAvancadoInteligenciaTerritorial:atualizar-lista-municipios', todosMunicipios);
                        this.setArrayTodosMunicipiosEstadoInteligenciaTerritorial(todosMunicipios);
                        setTimeout(() => {
                            todosMunicipios.forEach(municipio => {
                                const municipioId = Number(municipio.codigo);
                                if (arrayIdsMuncipios.includes(municipioId)) {
                                    arrayMunicipiosFiltrados.push(municipio?.nome);
                                }
                            });
                            this.setIdsMunicipiosInteligenciaTerritorialRanking(arrayMunicipiosFiltrados);
                        }, 100);
                    })
                    .catch(error => {
                        this.exibirNotify(
                            'error',
                            'Não foi possível buscar os dados de municipio.'
                        );
                        throw error;
                    });
            }
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },

        async buscarEstado(uf) {
            try {
                await LocalidadeService.findNivel1(1).then(
                    ({ data }) => {
                        let estados = data;
                        estados.filter(item => {
                            if (item.sigla === uf) {
                                this.estadoData = item;
                            }
                        });
                    }
                );
            } catch (e) {
                return '';
            }
        },

        addEscListener() {
            const vm = this;
            $(document).bind('fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange', function (e) {
                var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullscreenElement || document.msFullscreenElement;

                if (!fullscreenElement) {
                    vm.fullscreenAtivado = !vm.fullscreenAtivado;

                    if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                        $(vm.selectorIdMapa).prepend(
                            $('#drawer-menu-area')
                        );
                    }

                    if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                        $(vm.selectorIdMapa).prepend(
                            $('#drawer-menu-camadas')
                        );
                    }

                    if (vm.ativarFerramentasSentinelHub && vm.fullscreenAtivado) {
                        $(vm.selectorIdMapa).prepend(
                            $('#ferramentas-sentinel')
                        );
                        vm.handleSentinelInputsOnFullscreen();
                    }
                }
            });

            document.addEventListener('keyup', (e) => {
                if (e.keyCode === 27) {
                    $(
                        vm.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    $(vm.selectorIdMapa + ' .leaflet-interactive.drawCalc').removeClass('active');
                    $(vm.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                }
            });
        },

        addMapControls() {
            this.zoomControl();
            this.centralizeControl();

            if (this.mapConfig.controls.fullscreen) {
                this.fullscreenControl();
            }

            if (
                this.mapConfig.controls.buscarCarControl === undefined ||
                this.mapConfig.controls.buscarCarControl
            ) {
                this.addBuscaCarControl();
            }

            if (this.mapConfig.controls.camadasControl) {
                this.camadasControl();
            }

            if (this.usuarioLogado.sentinelHubAccess) {
                this.addBotaoSentinelHub();
            }

            L.control
                .coordinates({
                    position: 'bottomcenter',
                    decimals: 10,
                    decimalSeperator: '.',
                    labelTemplateLat: 'Latitude: {y}',
                    labelTemplateLng: 'Longitude: {x}'
                })
                .addTo(this.mapa);

            this.addBotaoArea();
            this.rulerControl();

            if (this.mapConfig.controls.drawControl) {
                this.drawControl();
            }
        },

        zoomControl() {
            L.control
                .zoom({
                    position: 'topright',
                    zoomControl: false
                })
                .addTo(this.mapa);
        },

        centralizeControl() {
            L.easyButton({
                id: 'botao-centralizar-zoom',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.centralize(),
                        title: 'Centralizar',
                        icon: 'mdi mdi-crosshairs-gps'
                    }
                ]
            }).addTo(this.mapa);
        },

        refreshMap() {
            this.mapa.invalidateSize();
            this.centralize();
        },

        centralize() {
            if (this.camadas.length === 0) {
                this.mapa.setView(
                    DEFAULT_CONFIG.center,
                    DEFAULT_CONFIG.zoom
                );
            }
        },

        fullscreenControl() {
            this.mapa.addControl(new L.Control.Fullscreen({position: 'topright'}));
        },

        addBuscaCarControl() {
            const config = {
                classeControle: 'leaflet-control-busca-car',
                position: 'topright'
            };
            ControleLeafletComComponenteVue(
                BuscaCar,
                this.mapa,
                { mapa: this.mapa },
                config
            );
        },

        showPopupAcoes(layer) {
            this.buscaCarGeometria = layer;
            let mapa = this.mapa;
            if (layer.options.draggable !== true) {
                layer.options.draggable = true;
                this.featureGroup.addLayer(layer);
                this.$emit('draw-created', layer);
            }

            let acoes = [];

            if (this.mapConfig.inspecionar) {
                acoes.push({
                    id: 2,
                    botao: '<i class="el el-icon-search text-white"><span> Inspecionar</span></i>',
                    acao: () => {
                        this.geometriaAcao = layer.toGeoJSON().geometry;
                        this.mostrarModalSelecionarCamadas = true;
                    }
                });
            }

            if (this.mapConfig.diagnostico) {
                acoes.push({
                    id: 3,
                    botao: '<i class="flow flow-environment text-white"><span> Diagnóstico</span></i>',
                    acao: () => {
                        this.geometriaAcao = layer.toGeoJSON().geometry;
                        this.setGeometriaDesenhadaAcao(this.geometriaAcao);
                        this.setAcaoEscolhida('DIAGNOSTICO');

                        this.$router.currentRoute.name ===
                            'DiagnosticoSocioambiental'
                            ? this.$emit('diagnostico', this.geometriaAcao)
                            : (this.mostrarModalEnviarGeometriaDiagnostico = true);
                    }
                });
            }

            acoes.push({
                id: 5,
                botao: '<i class="el el-icon-delete text-white"><span> Remover</span></i>',
                acao: () => {
                    this.$emit(
                        'removerTerritorio',
                        layer?.identificadorGeometria
                    );
                    mapa.removeLayer(layer);
                    this.buscaCarGeometria = null;
                }
            });

            const botaoHistoricoAgricola = {
                id: 1,
                botao: '<i class="flow flow-environment text-white"><span> Histórico agrícola</span></i>',
                acao: () => {
                    this.geometriaAcao = layer.toGeoJSON().geometry;
                    this.mostrarDrawerHistoricoAgricola = true;
                    this.closePopup();
                }
            };

            const botaoDownloadKml = {
                id: 4,
                botao: '<i class="el el-icon-download text-white"><span> Baixar polígono em KML</span></i>',
                acao: () => {
                    this.geometriaAcao = layer.toGeoJSON().geometry;
                    UtilsService.baixarKMLdeGeometria(
                        layer.toGeoJSON().geometry
                    );
                    this.closePopup();
                }
            };

            if (
                this.usuarioLogado.historicoMonitoramentoAccess &&
                (this.mapConfig.historicoMonitoramento === undefined ||
                    this.mapConfig.historicoMonitoramento === true)
            ) {
                acoes.push(botaoHistoricoAgricola);
            }

            if (layer.layerType === 'polygon') {
                acoes.push(botaoDownloadKml);
            }

            acoes = sortBy(acoes, ['id']);

            const elMenu = document.createElement('div');
            elMenu.setAttribute('id', 'menu-popup-ponto');

            const areaHa = this.formatAreaHa(
                geometryUtils.calcularAreaHaFromLayer(layer)
            );
            const areaInfo = document.createElement('p');
            if (layer.toGeoJSON().geometry.type !== 'Point') {
                areaInfo.innerHTML = `Área do polígono<br>${areaHa} (ha)`;
            }

            acoes.forEach(({ id, botao, acao }) => {
                const elBtnAcao = document.createElement('a');
                elBtnAcao.classList.add('btn');
                elBtnAcao.classList.add('container-botoes-inspecionar');
                if (id !== 5) {
                    elBtnAcao.classList.add('btn');
                } else {
                    elBtnAcao.classList.add('btn-danger');
                }

                elBtnAcao.innerHTML = botao;
                elBtnAcao.href = 'javascript:void(0)';
                elBtnAcao.onclick = acao;

                elMenu.appendChild(elBtnAcao);
            });

            if (layer.layerType === 'marker') {
                const elLatLng = document.createElement('p');
                elLatLng.setAttribute('class', 'latlng-popup');
                elLatLng.innerHTML = `Latitude: ${layer._latlng.lat.toFixed(
                    4
                )} <br> Longitude: ${layer._latlng.lng.toFixed(4)}`;

                elMenu.appendChild(elLatLng);
                this.limparMenuFerramentasAtivo = true;
            }

            elMenu.appendChild(areaInfo);

            layer.bindPopup(elMenu, {
                maxWidth: 'auto'
            });

            switch (layer.layerType) {
                case 'marker':
                    $(
                        '.leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    break;

                case 'polygon':
                    $('.leaflet-interactive.drawCalc').removeClass('active');
                    $('.leaflet-interactive.draw').removeClass('active');
                    break;
            }
        },

        formatAreaHa(areaHa) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        camadasControl() {
            L.easyButton({
                id: 'botao-camadas',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-camadas',
                        onClick: this.toggleMenuCamadas,
                        title: 'Camadas',
                        icon: 'mdi mdi-layers-outline'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoArea() {
            L.easyButton({
                id: 'botao-area',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-area',
                        onClick: this.toggleMenuArea,
                        title: 'Área',
                        icon: 'mdi mdi-vector-square mdi-flip-h'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoSentinelHub() {
            L.easyButton({
                id: 'botao-sentinel-hub',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-sentinel-hub',
                        onClick: this.toggleFerramentasSentinelHub,
                        title: 'Imagens Sentinel 2',
                        icon: 'mdi mdi-satellite-variant'
                    }
                ]
            }).addTo(this.mapa);
        },

        drawControlCalc() {
            const polyOptionsCalc = DrawCalc.OPTIONS;

            this.drawPolygonCalc = new L.Draw.Polygon(
                this.mapa,
                polyOptionsCalc
            );

            this.drawCalc();
        },

        drawCalc() {
            this.closePopup();
            if (!this.drawPolygonCalc.enabled()) {
                this.drawPolygonCalc.enable();
                $('.leaflet-interactive.drawCalc').addClass('active');
            } else {
                this.drawPolygonCalc.disable();
                $('.leaflet-interactive.drawCalc').removeClass('active');
            }
        },

        closePopup() {
            this.mapa.eachLayer(function (layer) {
                layer.closePopup();
            });
        },

        inspecionar(camadasSelecionasModal, tipo) {
            this.camadasInspecao = camadasSelecionasModal;
            this.mostrarModalSelecionarCamadas = false;

            this.mostrarDrawerInspecionar = true;

            const pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            if (this.geometriaAcao.coordinates.length === 2) {
                this.pinIcon = L.marker(
                    [
                        this.geometriaAcao.coordinates[1],
                        this.geometriaAcao.coordinates[0]
                    ],
                    { icon: pinIcon }
                );
                this.mapa.addLayer(this.pinIcon);
            }

            const vm = this;

            let fullscreenAtivado = document.querySelector(
                this.selectorIdMapa + ' [title="Exit Fullscreen"]'
            );

            if (fullscreenAtivado) {
                $(vm.selectorIdMapa).prepend(
                    $('#drawer-inspecionar-camadas')
                );
            }
        },

        atualizarListaCamadasModalInspecionar(camadas) {
            this.camadasInspecao = camadas.map(camada => camada.codigo);
        },

        fecharDrawerInspecionar() {
            this.mostrarDrawerInspecionar = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        drawerHistoricoAgricolaFechar() {
            this.mostrarDrawerHistoricoAgricola = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        rulerControl() {
            L.control.ruler(OptionsRuler.DEFAULT).addTo(this.mapa);
            $('.leaflet-bar.leaflet-ruler.leaflet-control').addClass('none');
        },

        rulerActivate() {
            setTimeout(() => {
                $(this.selectorIdMapa + ' .leaflet-bar.leaflet-ruler.leaflet-control').click();
            }, 200);
        },

        toggleMenuCamadas() {
            const vm = this;

            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            this.ativarMenuCamadas = !this.ativarMenuCamadas;
            this.botaoMenuAtivoCamadas('#botao-camadas');
            if (this.ativarMenuCamadas) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        $(vm.selectorIdMapa).prepend(
                            $('#drawer-menu-camadas')
                        );
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        drawControl() {
            const polyOptions = {
                allowIntersection: false,
                drawError: {
                    color: '#e1e100',
                    message:
                        '<strong>As arestas do polígono não devem se cruzar</strong>'
                },
                shapeOptions: {
                    color: '#bada55',
                    showMeasurements: false
                },
                icon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                }),
                touchIcon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                })
            };

            this.drawPolygon = new L.Draw.Polygon(this.mapa, polyOptions);
            document.addEventListener(
                'keydown',
                function (event) {
                    if (event.key === 'Escape' && this.drawPolygon.enabled()) {
                        this.drawPolygon.disable();
                        $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                    }
                }.bind(this)
            );
            L.easyButton({
                id: 'botao-desenhar',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.draw(),
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.desenhar'),
                        icon: 'mdi mdi-pencil-outline'
                    }
                ]
            }).addTo(this.mapa);

            $(this.selectorIdMapa + ` .leaflet-interactive[title="${this.$t('mensagens.menuMapa.iconesFerramentas.desenhar')}"]`).addClass('draw');
        },

        draw() {
            if (this.mapa.doubleClickZoom.enabled()) {
                if (!this.drawPolygon.enabled()) {
                    this.drawPolygon.enable();
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').addClass('active');
                } else {
                    this.drawPolygon.disable();
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                }
            }
        },

        toggleFerramentasSentinelHub() {
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            this.ativarFerramentasSentinelHub = !this.ativarFerramentasSentinelHub;
            this.botaoMenuAtivo('#botao-sentinel-hub', this.ativarFerramentasSentinelHub);
            if (this.ativarFerramentasSentinelHub) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        $(this.selectorIdMapa).prepend(
                            $('#ferramentas-sentinel')
                        );
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleMenuArea() {
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            this.ativarMenuArea = !this.ativarMenuArea;
            this.botaoMenuAtivo('#botao-area', this.ativarMenuArea);
            if (this.ativarMenuArea) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        $(this.selectorIdMapa).prepend(
                            $('#drawer-menu-area')
                        );
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        botaoMenuAtivo(seletor, condition) {
            if (condition) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        botaoMenuAtivoCamadas(seletor) {
            if (this.ativarMenuCamadas) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        handleSentinelInputsOnFullscreen() {
            let selectorIdMapa = this.selectorIdMapa;

            setTimeout(() => {
                let datePicker = document.querySelector(
                    selectorIdMapa + ' .el-date-editor'
                );
                datePicker.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        selectorIdMapa + ' [title="Exit Fullscreen"]'
                    );
                    let ferramentasSentinelContainer = document.querySelector(selectorIdMapa + ' #ferramentas-sentinel .el-drawer.rtl');
                    ferramentasSentinelContainer.addEventListener('click', function () {
                        setTimeout(() => {
                            $(selectorIdMapa + ' .leaflet-top').removeClass(
                                'fullscreen-ativado'
                            );
                        }, 10);
                    });
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(
                                selectorIdMapa +
                                ' .ferramentas-sentinel'
                            ).prepend(
                                $('.el-picker-panel.el-date-range-picker')
                            );
                            $(selectorIdMapa + ' .leaflet-top').addClass(
                                'fullscreen-ativado'
                            );
                        }, 20);
                    }
                });
            }, 300);
        },

        handleFullscreenClick() {
            if (this.mapConfig.controls.fullscreen) {
                const vm = this;
                var fullScreenButton = document.querySelector(
                    vm.selectorIdMapa + ' .leaflet-control-fullscreen-button'
                );

                fullScreenButton.addEventListener('click', function () {
                    vm.fullscreenAtivado = !vm.fullscreenAtivado;

                    setTimeout(() => {
                        if (vm.ativarMenuFerramentas && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-ferramentas')
                            );
                            vm.handleModalAnotacaoInputsOnFullscreen();
                        }

                        if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-area')
                            );
                        }

                        if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-camadas')
                            );
                        }

                        if (vm.ativarFerramentasSentinelHub && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#ferramentas-sentinel')
                            );
                            vm.handleSentinelInputsOnFullscreen();
                        }
                    }, 150);
                });
            }
        },

        handleClickOutsideMenus() {
            const vm = this;
            setTimeout(() => {
                window.onclick = function (event) {
                    var elDrawerCamadas = document.querySelector(
                        '#drawer-menu-camadas .el-drawer'
                    );
                    var elDrawerArea = document.querySelector(
                        '#drawer-menu-area .el-drawer'
                    );
                    var elDrawerSentinelHub = document.querySelector(
                        '#ferramentas-sentinel .el-drawer'
                    );

                    if (
                        event.target.contains(elDrawerCamadas) &&
                        event.target !== elDrawerCamadas
                    ) {
                        if (vm.ativarMenuCamadas) {
                            vm.toggleMenuCamadas();
                        }
                    }

                    if (
                        event.target.contains(elDrawerArea) &&
                        event.target !== elDrawerArea
                    ) {
                        if (vm.ativarMenuArea) {
                            vm.toggleMenuArea();
                        }
                    }

                    if (
                        event.target.contains(elDrawerSentinelHub) &&
                        event.target !== elDrawerSentinelHub
                    ) {
                        if (vm.ativarFerramentasSentinelHub) {
                            vm.toggleFerramentasSentinelHub();
                            setTimeout(() => {
                                $(vm.selectorIdMapa + ' .leaflet-top').removeClass(
                                    'fullscreen-ativado'
                                );
                            }, 10);
                        }
                    }
                };
            }, 200);
        }
    }
};
</script>

<style lang="scss">
.leaflet-top.leaflet-right .mdi:before,
.leaflet-top.leaflet-right .mdi-set {
    font-size: large !important;
}
.leaflet-interactive:focus {
    outline: none !important;
}
</style>
